export const parseJwt = (token) => {
  try {
    const decoded = JSON.parse(atob(token.split(".")[1]));
    return {
      id: decoded["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier"],
      email: decoded.email,
      name: decoded["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name"],
      role: decoded["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"],
    };
  } catch (e) {
    return null;
  }
};